import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { serverInstance } from "../../service/axios";
import Criteria from "./Criteria";
import "./exam.scss";
import Rules from "./Rules";

const Examination = ({ data }) => {
  const params = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);
  const [formLink, setFormLink] = useState("");

  useEffect(() => {
    getExaminationForm();
    setTimeout(() => {
      window.scrollTo(0, 0); 
    });
  }, []);

  useEffect(() => {
    if (params.tab === "criteria") {
      setActiveTab(0)
    }
    else if (params.tab === "rules") {
      setActiveTab(1)
    }
    else if (params.tab === "register") {
      // setActiveTab(2)
    }
    else {
      setActiveTab(0)
    }
  }, [params.tab])

  const getExaminationForm = () => {
    serverInstance.post("/app/item", { class: "setting", id: "EXAMINATION_GOOGLE_FORM" }, {
      headers: {
        "Content-Type": "application/json",
      }
    })
    .then(res => {
      setFormLink(res.data.item.link)
    })
  }

  const goTo = (index) => {
    if (index === 2) {
      if (formLink) {
        window.open(formLink, "_blank")
      }
    }
    else {
      navigate(data.categoryLinks[index])
    }
  }

  return (
    <div className='exam-container d-flex flex-column align-items-center '>
      <h2>{data.title}</h2>

      <section className="exam-main">
        <div className="tabs">
          {data.tabs.map((tab, index) => {
            return (
              <div className={'tab-item' + (index === activeTab ? " active" : "")} key={'tab-' + index}
                onClick={() => goTo(index)}>
                {tab}
              </div>
            )
          })}
        </div>
        <div className="exam-content">
          {activeTab === 0 ?
            <Criteria />
          : activeTab === 1 ?
            <Rules/>
          : activeTab === 2 ?
            <Rules/>
          : null}
        </div>
      </section>
    </div>
  );
};
export default Examination;
